<template>
  <div id="wrapper">

    <div class="normalheader transition">
      <div class="hpanel">
        <div class="panel-body">
          <div id="hbreadcrumb" class="pull-right m-t-lg">
            <ol class="hbreadcrumb breadcrumb">
              <li><router-link :to="{name: 'Projects'}">Projects</router-link></li>
              <li><router-link :to="{name: 'ProjectDetails', params: {id: projectId}}">Project Overview</router-link></li>
              <li class="active">Contact Overview</li>
            </ol>
          </div>
          <h3 class="font-light m-b-xs">
            Contact Overview - <router-link v-if="project" class="font-bold text-info" :to="{name: 'ProjectDetails', params: {id: projectId}}">{{project.name}}</router-link>
          </h3>
          <small>Prepare and manage emails to experts</small>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="row">
        <div class="col-xs-12">
          <div class="hpanel">
            <div class="panel-heading">
              Workflow steps:
            </div>
            <div class="panel-body">
              <breadcrumb-box  :projectId="projectId" :activeStep="'contact'" ></breadcrumb-box>
            </div>
          </div>
        </div>

      </div>

      <div class="row">

        <div class="col-xs-12">
          <question-resume :projectId="projectId" :questionId="questionId" :workflowId="workflowId" :large="true"/>
        </div>
      </div>

      <question-mailing-overview :projectId="projectId" :questionId="questionId"></question-mailing-overview>
    </div>

  </div>
</template>

<style scoped>
  .forum-box .panel-heading {
    padding: 10px 4px;
  }
</style>

<script>
import QuestionResume from '../../components/question/QuestionResume'
import QuestionMailingOverview from '../../components/question/QuestionMailingOverview'
import BreadcrumbBox from '../../components/project/BreadcrumbBox'

export default {
  components: {QuestionResume, BreadcrumbBox, QuestionMailingOverview},
  props: [],
  name: 'MailingReview',
  methods: {
    getResources: function () {
      this.axios.get('/project/' + this.$route.params.project_id)
        .then((response) => {
          this.project = response.data
          this.workflowId = this.project.workflow_id
        })
        .catch((error) => {
          if (error.response.status === 403) {
            this.$router.replace({name: 'Error403', params: {'0': ''}})
          }
          if (error.response.status === 404) {
            this.$router.replace({name: 'Error404', params: {'0': ''}})
          }
        })
    }
  },
  data () {
    return {
      question: null,
      projectId: null,
      project: null,
      workflowId: null,
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      }
    }
  },
  beforeMount () {
    this.projectId = this.$route.params.project_id
    this.questionId = this.$route.params.question_id

    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/mailing/MailingReview.vue